/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import {dlsColor} from '../../theme/theme';

const useStyles = makeStyles(theme => ({
  root : {
    '& .MuiCircularProgress-colorPrimary' : {
      color : dlsColor('caBlue')
    },
    margin : ({margin}: {margin?: string}) => margin || '7px 6px 0px 0px'
  }
}));

interface ButtonSpinnerProps {
  size?: number;
  margin?: string;
  overrideClassName?: string;
}

/**
 * @ButtonSpinner
 *
 * Defines the ButtonSpinner component. This component is used to show motion indicator
 * while Sign in.
 *
 * ```typescript
 *
 * <ButtonSpinner />
 *
 * ```
 */
export const ButtonSpinner = ({size = 30, margin, overrideClassName}: ButtonSpinnerProps) => {
  const classes = useStyles({margin});
  return (
    <div className={classnames(classes.root, overrideClassName)}>
      <CircularProgress size={size} />
    </div>
  );
};
